import { IAdminGroup } from '../../../../../store/admin/groups/store';
import { allGroupId, ISelectedGroups } from '../InvitePlayers';

type TGetSelectedGroups = (
  previoulySelectedGroups: ISelectedGroups,
  selectedGroup: IAdminGroup
) => { [key: number]: boolean };

export const getSelectedGroups: TGetSelectedGroups = (previoulySelectedGroups, selectedGroup) => {
  const allIsSelected = previoulySelectedGroups[allGroupId];
  const groupPreviousSelection = previoulySelectedGroups[selectedGroup.id];

  return selectedGroup.id === allGroupId
    ? Object.keys(previoulySelectedGroups).reduce(
        (
          acc: {
            [key: number]: boolean;
          },
          groupId: string
        ) => ({
          ...acc,
          [Number(groupId)]: !allIsSelected
        }),
        {}
      )
    : {
        ...previoulySelectedGroups,
        [selectedGroup.id]: !groupPreviousSelection,
        [allGroupId]: groupPreviousSelection ? false : allIsSelected
      };
};
